import { create } from 'zustand';
import cookieInfo from '@alife/bc-cookie-info';
import fetchJsonp from 'fetch-jsonp';
import { domainHost } from '@/common/country-site';

const PRODUCT_ADD_CART = `//carp.${domainHost()}/addPurchaseItem.jsonp`;

type State = {
  data: {
    success: boolean;
    message: string;
  };
};

type Action = {
  del: () => void;
  add: (
    params: {
      productId: string;
      dispatchLocation: string;
      skuId: string;
      quantity: number;
    }[],
  ) => void;
};

const requestOptions = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
};

const CartStore = create<State & Action>((set) => ({
  data: {
    success: false,
    message: '',
  },
  del: () => {
    set({
      data: {
        success: false,
        message: '',
      },
    });
  },
  add: async (params) => {
    // 临时回归代码
    const result = await fetchJsonp(
      `${PRODUCT_ADD_CART}?_tb_token_=${cookieInfo.getCookie('_tb_token_')}&dmtrack_pageid=${
        window.dmtrack_pageid
      }&purchaseItemsData=${encodeURIComponent(JSON.stringify(params))}`,
    ).then((res) => res.json());
    set({
      data: {
        success: true,
        message: result.success === true ? '' : result.message,
      },
    });
  },
}));

export default CartStore;
